export default __webpack_public_path__ + "hero-demo.png?c2cb556325969b497b323405526db16c";